import { fetchWithAuth } from './fetchWithAuth'

export async function updateVenue(
  token: string,
  id: string,
  body: Record<string, unknown>,
): Promise<void> {
  await fetchWithAuth(`/v1/venues/${id}`, token, {
    method: 'PUT',
    body: JSON.stringify(body),
  })
}
